
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import styles from './index.module.scss';
import Layout from '../../components/Layout';
import { Namespace } from '../../enums/namespaces';
import { StaticPathParams } from '../../typings/staticPaths';
import Head from 'next/head';
import { basicSEO } from 'helpers/jsx';
import { withForcePlanToLoggedInUnsubs } from 'context';
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import { createRedirectIfNeeded } from 'helpers';
import { Country } from '../../enums/country';

interface Props {
  countryCode: string;
}

const Contact: NextPage<null> = ({ countryCode }: Props) => {
  const { t } = useTranslation(Namespace.Contact);

  return (
    <Layout countryCode={countryCode}>
      <Head>{basicSEO(t('seo:contact_title'), t('seo:contact_description'))}</Head>
      <main className={styles.contact}>
        <div className={styles.sectionWrapper}>
          <div className={styles.heading}>
            <h1>{t('authorship_provider')}</h1>
            <address>
              {countryCode === Country.Ukraine ? t('ua_company') : t('company')}
              <br />
              {countryCode === Country.Ukraine ? t('ua_address') : t('address')}
              <br />
              {countryCode === Country.Ukraine ? t('ua_ico') : t('ico')}
            </address>

            <a
              href={`mailto:${countryCode === Country.Ukraine ? t('ua_cooperation') : t('cooperation')}`}
              target="_blank"
            >
              {countryCode === Country.Ukraine ? t('ua_cooperation') : t('cooperation')}
            </a>
          </div>
          <ul>
            {countryCode !== Country.Ukraine ? (
              <>
                {' '}
                <li>
                  <div className={styles.img}>
                    <img src="/jpg/img-zavadil.jpg" width={270} height={320} />
                  </div>

                  <h3>{t('contact_ceo')}</h3>
                  <h2>{t('person_title_1')}</h2>
                  <a href="mailto:martin@dramox.cz" target="_blank">
                    martin@dramox.cz
                  </a>
                </li>
                <li>
                  <div className={styles.img}>
                    <img src="/jpg/img-hajek.jpg" width={270} height={320} />
                  </div>

                  <h3>{t('contact_cofounder')}</h3>
                  <h2>{t('person_title_3')}</h2>
                </li>
              </>
            ) : (
              <li>
                <div className={styles.img}>
                  <img
                    srcSet={`/jpg/img-olia.jpg 1x, /jpg/img-olia@2x.jpg 2x`}
                    src="/jpg/img-olia.jpg"
                    width={270}
                    height={320}
                  />
                </div>

                <h3>{t('ua_contact')}</h3>
                <h2>{t('ua_contact_name')}</h2>
                <a href="mailto:olia.shylo@dramox.tv" target="_blank">
                  olia.shylo@dramox.tv
                </a>
              </li>
            )}
          </ul>
        </div>
        <div className={styles.press}>
          <h2>{t('press_media')}</h2>
          <p>{t('press_text')}</p>
          <a
            target="_blank"
            href="https://drive.google.com/drive/folders/1lRCXvMveQ6c9k83I3i6OFF-GeVeg9yNZ?usp=drive_link"
          >
            {t('press_download')}
          </a>
        </div>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { locale, apiClient, countryCode } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  return {
    props: {
      countryCode,
    },
  };
}

export default withForcePlanToLoggedInUnsubs(Contact);


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/contact/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  